import { __assign } from "tslib";
import { renderAndMountComponent } from '@wix/answers-lib';
import * as React from 'react';
import { LabelView, labelViewKey } from './label-view';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
export var createLabelViewDriver = function (wrapper, extra) {
    if (extra === void 0) { extra = ''; }
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, "." + labelViewKey + extra, labelViewKey);
    return {
        getName: function () { return baseDriver.getText(); },
        remove: function () { return baseDriver.click(); }
    };
};
export var createLabelView = function (props) {
    var elem = renderAndMountComponent(React.createElement(LabelView, __assign({}, props)));
    return createLabelViewDriver(elem);
};
//# sourceMappingURL=label-view.driver.js.map